<script setup lang="ts">
import { computed, ref, watch, type PropType } from 'vue'
import { assetUrl } from '../core/assets'

const props = defineProps({
  src: { type: String, default: undefined },
  assetKey: { type: String, default: undefined },
  alt: { type: String, required: true },
  loading: {
    type: String as PropType<'eager' | 'lazy'>,
    default: 'lazy',
  },
  fetchPriority: {
    type: String as PropType<'high' | 'low' | 'auto'>,
    default: 'auto',
  },
})
const failed = ref(false)
const resolved = computed(() => props.src ?? assetUrl(props.assetKey) ?? '')

watch(resolved, () => {
  failed.value = false
})

function fail(): void {
  failed.value = true
}
</script>

<template>
  <span class="asset-image">
    <img
      v-if="!failed && resolved !== ''"
      :src="resolved"
      :alt="props.alt"
      :loading="props.loading"
      :fetchpriority="props.fetchPriority"
      decoding="async"
      @error="fail"
    />
    <span v-else class="asset-fallback" role="img" :aria-label="props.alt">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        aria-hidden="true"
      >
        <path d="M4 5h16v14H4z" />
        <path d="m6 16 4-4 3 3 2-2 3 3" />
        <path d="M15 9h.01" />
      </svg>
    </span>
  </span>
</template>
